import React, { useEffect, useState } from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { ClassNameMap } from '@mui/styles/withStyles';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import Dashboard from '../../../layouts/Dashboard';
import ListEvents from '../../../components/Global/Events/List';

import styles from './styles';
import { Filters } from '../../../components/Global/Events/List/FiltersPane';
import { Emergency, Section, eventsInitQuery } from './queries';
import { useQuery } from '@apollo/client';

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  classes: ClassNameMap<string>;
}

interface State {
  sections: Section[];
  emergencies: Emergency[];
}

const ListEventsArea = ({ classes, history }: Props): React.ReactElement => {
  const [filters, setFilters] = useState<Filters>({ areas: [], emergencies: [], sections: [] });

  const [pageState, setPageState] = useState<State>({
    sections: [],
    emergencies: [],
  });

  const { data: eventsData } = useQuery(eventsInitQuery(), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    let mounted = true;
    if (mounted && eventsData) {
      setPageState({
        sections: eventsData.area_sections,
        emergencies: eventsData.emergencies,
      });
    }
    return () => {
      mounted = false;
    };
  }, [eventsData]);

  return (
    <Dashboard title="Reports">
      <ListEvents filterOptions={{ areas: [], sections: pageState.sections, emergencies: pageState.emergencies }} filters={filters} setFilters={setFilters} />
    </Dashboard>
  );
};

export default withRouter(withStyles(styles)(ListEventsArea));
